import { render, staticRenderFns } from "./OfferLetterView.vue?vue&type=template&id=166bfe0b&"
import script from "./OfferLetterView.vue?vue&type=script&lang=js&"
export * from "./OfferLetterView.vue?vue&type=script&lang=js&"
import style0 from "./OfferLetterView.vue?vue&type=style&index=0&id=166bfe0b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports